export default "__VITE_ASSET__Bdni$Ksf__"